import util from '../../lib/util';
import {workingSet} from './mergeContext';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from '../find';
import CaseType from '../../entities/caseType';
import Matter from '../../entities/matter';
import CaseTypeStage from '../../entities/caseTypeStage';
import DeadlineRule from '../../entities/deadlineRule';
import Lead from '../../entities/lead';
import Question from '../../entities/question';
import RedFlagType from '../../entities/redFlagType';
export function deleteCaseType(caseType: CaseType, mergeId?: string) {
let targetImportSource = 'merge';
if (!mergeId) {targetImportSource = 'delete';mergeId = caseType.id;}
const _work = workingSet();
store.getState().matters.getMappingFor('caseTypeId', caseType.id).filter(matterTemp => matterTemp.status !== 'D').forEach(matterTemp => {
const _matter = ((_work.get('matter:' + matterTemp.id) ?? matterTemp) as Matter).clone();
_matter.status = 'U';
_matter.addedOn = newHRTimestamp();
_matter.addedBy = getCurrentUserId();
_matter.importSource = targetImportSource;
_matter.importId = mergeId;
if (_matter.caseTypeId === caseType.id) {
_matter.caseTypeId = null;

}
_work.set('matter:' + _matter.id, _matter);
store.dispatch(Actions.MatterActions.saveMatterQueue(_matter));
});
store.getState().caseTypeStages.getMappingFor('caseTypeId', caseType.id).filter(caseTypeStageTemp => caseTypeStageTemp.status !== 'D').forEach(caseTypeStageTemp => {
const _caseTypeStage = ((_work.get('caseTypeStage:' + caseTypeStageTemp.id) ?? caseTypeStageTemp) as CaseTypeStage).clone();
_caseTypeStage.status = 'U';
_caseTypeStage.addedOn = newHRTimestamp();
_caseTypeStage.addedBy = getCurrentUserId();
_caseTypeStage.importSource = targetImportSource;
_caseTypeStage.importId = mergeId;
if (_caseTypeStage.caseTypeId === caseType.id) {
_caseTypeStage.caseTypeId = '';

}
_work.set('caseTypeStage:' + _caseTypeStage.id, _caseTypeStage);
store.dispatch(Actions.CaseTypeStageActions.saveCaseTypeStageQueue(_caseTypeStage));
});
store.getState().deadlineRules.getMappingFor('caseTypeId', caseType.id).filter(deadlineRuleTemp => deadlineRuleTemp.status !== 'D').forEach(deadlineRuleTemp => {
const _deadlineRule = ((_work.get('deadlineRule:' + deadlineRuleTemp.id) ?? deadlineRuleTemp) as DeadlineRule).clone();
_deadlineRule.status = 'U';
_deadlineRule.addedOn = newHRTimestamp();
_deadlineRule.addedBy = getCurrentUserId();
_deadlineRule.importSource = targetImportSource;
_deadlineRule.importId = mergeId;
if (_deadlineRule.caseTypeId === caseType.id) {
_deadlineRule.caseTypeId = null;

}
_work.set('deadlineRule:' + _deadlineRule.id, _deadlineRule);
store.dispatch(Actions.DeadlineRuleActions.saveDeadlineRuleQueue(_deadlineRule));
});
store.getState().leads.getMappingFor('caseTypeId', caseType.id).filter(leadTemp => leadTemp.status !== 'D').forEach(leadTemp => {
const _lead = ((_work.get('lead:' + leadTemp.id) ?? leadTemp) as Lead).clone();
_lead.status = 'U';
_lead.addedOn = newHRTimestamp();
_lead.addedBy = getCurrentUserId();
_lead.importSource = targetImportSource;
_lead.importId = mergeId;
_lead.caseTypes = _lead.caseTypes?.filter(id => id !== caseType.id) || [];

_work.set('lead:' + _lead.id, _lead);
store.dispatch(Actions.LeadActions.saveLeadQueue(_lead));
});
store.getState().questions.getMappingFor('appliesTo', caseType.id).filter(questionTemp => questionTemp.status !== 'D').forEach(questionTemp => {
const _question = ((_work.get('question:' + questionTemp.id) ?? questionTemp) as Question).clone();
_question.status = 'U';
_question.addedOn = newHRTimestamp();
_question.addedBy = getCurrentUserId();
_question.importSource = targetImportSource;
_question.importId = mergeId;
_question.appliesTo = _question.appliesTo?.filter(id => id !== caseType.id) || [];

_work.set('question:' + _question.id, _question);
store.dispatch(Actions.QuestionActions.saveQuestionQueue(_question));
});
store.getState().redFlagTypes.getMappingFor('appliesTo', caseType.id).filter(redFlagTypeTemp => redFlagTypeTemp.status !== 'D').forEach(redFlagTypeTemp => {
const _redFlagType = ((_work.get('redFlagType:' + redFlagTypeTemp.id) ?? redFlagTypeTemp) as RedFlagType).clone();
_redFlagType.status = 'U';
_redFlagType.addedOn = newHRTimestamp();
_redFlagType.addedBy = getCurrentUserId();
_redFlagType.importSource = targetImportSource;
_redFlagType.importId = mergeId;
_redFlagType.appliesTo = _redFlagType.appliesTo?.filter(id => id !== caseType.id) || [];

_work.set('redFlagType:' + _redFlagType.id, _redFlagType);
store.dispatch(Actions.RedFlagTypeActions.saveRedFlagTypeQueue(_redFlagType));
});



caseType.status = 'D';
caseType.addedOn = newHRTimestamp();
caseType.addedBy = getCurrentUserId();
caseType.importSource = targetImportSource;
caseType.importId = mergeId;
store.dispatch(Actions.CaseTypeActions.removeCaseTypeQueue(caseType));
}
export function replaceCaseType(caseType: CaseType, replaceWith: CaseType, mergeId?: string) {
let targetImportSource = 'merge';
if (!mergeId) {targetImportSource = 'delete';mergeId = caseType.id;}
const _work = workingSet();
store.getState().matters.getMappingFor('caseTypeId', caseType.id).filter(matterTemp => matterTemp.status !== 'D').forEach(matterTemp => {
const _matter = ((_work.get('matter:' + matterTemp.id) ?? matterTemp) as Matter).clone();
_matter.status = 'U';
_matter.addedOn = newHRTimestamp();
_matter.addedBy = getCurrentUserId();
_matter.importSource = targetImportSource;
_matter.importId = mergeId;
if (_matter.caseTypeId === caseType.id) {
_matter.caseTypeId = replaceWith.id;

}
_work.set('matter:' + _matter.id, _matter);
store.dispatch(Actions.MatterActions.saveMatterQueue(_matter));
});
store.getState().caseTypeStages.getMappingFor('caseTypeId', caseType.id).filter(caseTypeStageTemp => caseTypeStageTemp.status !== 'D').forEach(caseTypeStageTemp => {
const _caseTypeStage = ((_work.get('caseTypeStage:' + caseTypeStageTemp.id) ?? caseTypeStageTemp) as CaseTypeStage).clone();
_caseTypeStage.status = 'U';
_caseTypeStage.addedOn = newHRTimestamp();
_caseTypeStage.addedBy = getCurrentUserId();
_caseTypeStage.importSource = targetImportSource;
_caseTypeStage.importId = mergeId;
if (_caseTypeStage.caseTypeId === caseType.id) {
_caseTypeStage.caseTypeId = replaceWith.id;

}
_work.set('caseTypeStage:' + _caseTypeStage.id, _caseTypeStage);
store.dispatch(Actions.CaseTypeStageActions.saveCaseTypeStageQueue(_caseTypeStage));
});
store.getState().deadlineRules.getMappingFor('caseTypeId', caseType.id).filter(deadlineRuleTemp => deadlineRuleTemp.status !== 'D').forEach(deadlineRuleTemp => {
const _deadlineRule = ((_work.get('deadlineRule:' + deadlineRuleTemp.id) ?? deadlineRuleTemp) as DeadlineRule).clone();
_deadlineRule.status = 'U';
_deadlineRule.addedOn = newHRTimestamp();
_deadlineRule.addedBy = getCurrentUserId();
_deadlineRule.importSource = targetImportSource;
_deadlineRule.importId = mergeId;
if (_deadlineRule.caseTypeId === caseType.id) {
_deadlineRule.caseTypeId = replaceWith.id;

}
_work.set('deadlineRule:' + _deadlineRule.id, _deadlineRule);
store.dispatch(Actions.DeadlineRuleActions.saveDeadlineRuleQueue(_deadlineRule));
});
store.getState().leads.getMappingFor('caseTypeId', caseType.id).filter(leadTemp => leadTemp.status !== 'D').forEach(leadTemp => {
const _lead = ((_work.get('lead:' + leadTemp.id) ?? leadTemp) as Lead).clone();
_lead.status = 'U';
_lead.addedOn = newHRTimestamp();
_lead.addedBy = getCurrentUserId();
_lead.importSource = targetImportSource;
_lead.importId = mergeId;
_lead.caseTypes = _lead.caseTypes?.map(id => (id === caseType.id) ? replaceWith.id : id) || [];

_work.set('lead:' + _lead.id, _lead);
store.dispatch(Actions.LeadActions.saveLeadQueue(_lead));
});
store.getState().questions.getMappingFor('appliesTo', caseType.id).filter(questionTemp => questionTemp.status !== 'D').forEach(questionTemp => {
const _question = ((_work.get('question:' + questionTemp.id) ?? questionTemp) as Question).clone();
_question.status = 'U';
_question.addedOn = newHRTimestamp();
_question.addedBy = getCurrentUserId();
_question.importSource = targetImportSource;
_question.importId = mergeId;
_question.appliesTo = _question.appliesTo?.map(id => (id === caseType.id) ? replaceWith.id : id) || [];

_work.set('question:' + _question.id, _question);
store.dispatch(Actions.QuestionActions.saveQuestionQueue(_question));
});
store.getState().redFlagTypes.getMappingFor('appliesTo', caseType.id).filter(redFlagTypeTemp => redFlagTypeTemp.status !== 'D').forEach(redFlagTypeTemp => {
const _redFlagType = ((_work.get('redFlagType:' + redFlagTypeTemp.id) ?? redFlagTypeTemp) as RedFlagType).clone();
_redFlagType.status = 'U';
_redFlagType.addedOn = newHRTimestamp();
_redFlagType.addedBy = getCurrentUserId();
_redFlagType.importSource = targetImportSource;
_redFlagType.importId = mergeId;
_redFlagType.appliesTo = _redFlagType.appliesTo?.map(id => (id === caseType.id) ? replaceWith.id : id) || [];

_work.set('redFlagType:' + _redFlagType.id, _redFlagType);
store.dispatch(Actions.RedFlagTypeActions.saveRedFlagTypeQueue(_redFlagType));
});



return caseType;
}
export function deleteImpactCaseType(caseType: CaseType) {
const impacts: string[] = [];
const state = store.getState();
const matterCaseTypeIdImpact = state.matters.getMappingFor('caseTypeId', caseType.id).filter(matter => matter.status !== 'D');
matterCaseTypeIdImpact.forEach(() => impacts.push('matters'));
const caseTypeStageCaseTypeIdImpact = state.caseTypeStages.getMappingFor('caseTypeId', caseType.id).filter(caseTypeStage => caseTypeStage.status !== 'D');
caseTypeStageCaseTypeIdImpact.forEach(() => impacts.push('caseTypeStages*'));
const deadlineRuleCaseTypeIdImpact = state.deadlineRules.getMappingFor('caseTypeId', caseType.id).filter(deadlineRule => deadlineRule.status !== 'D');
deadlineRuleCaseTypeIdImpact.forEach(() => impacts.push('deadlineRules'));
const leadCaseTypesImpact = state.leads.getMappingFor('caseTypeId', caseType.id).filter(lead => lead.status !== 'D');
leadCaseTypesImpact.forEach(() => impacts.push('leads'));
const questionAppliesToImpact = state.questions.getMappingFor('appliesTo', caseType.id).filter(question => question.status !== 'D');
questionAppliesToImpact.forEach(() => impacts.push('questions'));
const redFlagTypeAppliesToImpact = state.redFlagTypes.getMappingFor('appliesTo', caseType.id).filter(redFlagType => redFlagType.status !== 'D');
redFlagTypeAppliesToImpact.forEach(() => impacts.push('redFlagTypes'));



return util.countDistinct(impacts);
}
